import store from '@/store';
import user from './user';
import downloads from './downloads';
import users from './admin/users';
import diodes from './admin/diodes';
import devices from './devices';


export default async function() {
  store.set('loading', true);
  try {
    const requests = [];

    // load user data
    await user.load(); // we need to load this in series so we can tell if user is super
    requests.push(devices.load());

    // load admin data
    if (store.get('user').is_superuser){
      users.load(); // don't wait for these, so don't push on promise array
      diodes.load();
    }

    // load support downloads
    store.set('downloads', await downloads.fetch());

    // for for all requests to finish
    await Promise.all(requests);

    store.set('loaded', true);
    store.set('loading', false);
  } catch (error) {
    store.set('error', 'We are having trouble loading the page, please refresh.');
    throw error;
  }

}
